import { IsNotEmpty } from "class-validator";
import { IBase, IVariation } from "../../interfaces";

export class VariationDTO implements Omit<IVariation, keyof IBase> {
  @IsNotEmpty({ message: 'Le nom de la taille est requis' })
  name: string;
}
